const apiErrorHandler = (errorObj) => {
  const { message, detail } = errorObj
  if (detail) return { message: detail }
  return message ? message : { http_code: 500, message: 'Something went wrong' }
}

export { apiErrorHandler }
